import { Stack } from "@certn/cascadia";
import { RenderContext } from "@certn/cascadia-react/context/RenderContext";
import {
  ExpandCollapseAll,
  showExpandCollapseAllControl,
} from "@certn/forms/src/components/ExpandCollapseAll";
import { ArrayLayoutProps } from "@jsonforms/core";
import React, { useContext, useMemo } from "react";
import { useState } from "react";
import { ItemsHeading } from "./ItemsHeading";
import { hasHeading } from "./utils";
import { getItemStyle, ItemStyle } from "../../utils";

interface Props {
  paths: { path: string }[];
  children: (
    path: { path: string },
    isOpen: boolean,
    index: number
  ) => React.ReactNode;
}

export function Wrapper(props: ArrayLayoutProps & Props) {
  const [isOpen, setIsOpen] = useState<boolean>(
    props.uischema.options?.initialState ?? false
  );
  const isPDF = useContext(RenderContext).isForPdfGeneration;

  const itemStyle = useMemo(
    () => getItemStyle(props.uischema),
    [props.uischema]
  );
  const hasChildren = useMemo(() => props.paths.length > 0, [props.paths]);
  const showHeadingContainer = useMemo(() => {
    return (
      hasHeading(props) ||
      (showExpandCollapseAllControl(isPDF, props.uischema.options) &&
        itemStyle === ItemStyle.CARD)
    );
  }, [itemStyle, props.uischema.options, isPDF]);

  if (!hasChildren && !hasHeading(props)) {
    return <></>;
  }

  return (
    <Stack gap="space-3">
      {showHeadingContainer && (
        <Stack orientation="horizontal" justify="space-between">
          <ItemsHeading {...props} />
          {itemStyle === ItemStyle.CARD && (
            <ExpandCollapseAll isOpen={isOpen} setIsOpen={setIsOpen} />
          )}
        </Stack>
      )}
      {props.paths.map((path, index) =>
        props.children(path, isOpen || isPDF, index)
      )}
    </Stack>
  );
}
